import { DatePipe } from "@angular/common";
import { inject, Pipe, PipeTransform } from "@angular/core";
import moment from "moment";

@Pipe({
  name: "age",
})
export class AgePipe implements PipeTransform {
  private datePipe = inject(DatePipe);

  transform(birthday: string | Date): unknown {
    const date = this.datePipe.transform(birthday, "yyyy-MM-dd");
    const result = moment().diff(moment(date), "years");
    return result;
  }
}
